import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/imgs/advert/ios-bg.png';
import _imports_1 from '../../assets/imgs/advert/android-bg.png';
import _imports_2 from '../../assets/imgs/advert/circle-left.png';
import _imports_3 from '../../assets/imgs/advert/circle-right.png';
import _imports_4 from '../../assets/imgs/advert/title-bg.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-ee29cec0"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  key: 0,
  class: "loading"
};
var _hoisted_2 = ["oversea"];
var _hoisted_3 = {
  key: 0,
  class: "header-bg-img",
  src: _imports_0
};
var _hoisted_4 = {
  key: 1,
  class: "header-bg-img",
  src: _imports_1
};

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    class: "left-bg-img",
    src: _imports_2
  }, null, -1);
});

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    class: "right-bg-img",
    src: _imports_3
  }, null, -1);
});

var _hoisted_7 = {
  class: "advert-time"
};

var _hoisted_8 = /*#__PURE__*/_createTextVNode(" ： ");

var _hoisted_9 = {
  key: 0,
  class: "time-day-container"
};
var _hoisted_10 = {
  class: "time-label time-day time-label-text"
};
var _hoisted_11 = {
  class: "time-label-text"
};

var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "time-unit"
  }, "D", -1);
});

var _hoisted_13 = {
  class: "time-label time-hour"
};
var _hoisted_14 = {
  class: "time-label-text"
};

var _hoisted_15 = /*#__PURE__*/_createTextVNode(": ");

var _hoisted_16 = {
  class: "time-label time-minute"
};
var _hoisted_17 = {
  class: "time-label-text"
};

var _hoisted_18 = /*#__PURE__*/_createTextVNode(": ");

var _hoisted_19 = {
  class: "time-label time-seconds"
};
var _hoisted_20 = {
  class: "time-label-text"
};
var _hoisted_21 = {
  key: 2,
  class: "vip-discount-cards"
};
var _hoisted_22 = {
  class: "vip-discount-content"
};
var _hoisted_23 = {
  class: "vip-discount-card-left"
};
var _hoisted_24 = {
  class: "title"
};
var _hoisted_25 = {
  class: "title-name"
};
var _hoisted_26 = {
  key: 0,
  class: "discount-label"
};
var _hoisted_27 = {
  key: 0,
  class: "first-tag"
};
var _hoisted_28 = {
  class: "price"
};
var _hoisted_29 = {
  class: "real-price"
};
var _hoisted_30 = {
  class: "num"
};
var _hoisted_31 = ["onClick"];
var _hoisted_32 = {
  key: 3,
  class: "vip-discount-cards"
};
var _hoisted_33 = {
  class: "vip-discount-content"
};
var _hoisted_34 = {
  class: "vip-discount-card-left"
};
var _hoisted_35 = {
  class: "title"
};
var _hoisted_36 = {
  key: 0,
  class: "discount-label"
};
var _hoisted_37 = {
  class: "price"
};
var _hoisted_38 = {
  class: "real-price"
};
var _hoisted_39 = {
  class: "num"
};
var _hoisted_40 = {
  class: "origin-price"
};
var _hoisted_41 = ["onClick"];
var _hoisted_42 = {
  class: "vip-discount-desc"
};
var _hoisted_43 = {
  class: "advert-explains"
};

var _hoisted_44 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "advert-explain-title"
  }, [/*#__PURE__*/_createElementVNode("img", {
    class: "title-bg title-bg-left",
    src: _imports_4
  }), /*#__PURE__*/_createTextVNode(" Activity description: "), /*#__PURE__*/_createElementVNode("img", {
    class: "title-bg title-bg-right",
    src: _imports_4
  })], -1);
});

var _hoisted_45 = {
  key: 0,
  class: "advert-explain-inner"
};

var _hoisted_46 = /*#__PURE__*/_createStaticVNode("<li class=\"advert-explain\" data-v-ee29cec0>The mid-year special offer will last from 2024.07.04 to 2024.07.18;</li><li class=\"advert-explain\" data-v-ee29cec0>During the activity, users can enjoy a membership discount of up to 50% off;</li><li class=\"advert-explain\" data-v-ee29cec0>After the recharge is successful, you can check the validity period of your membership in &quot;Mine-Membership&quot;;</li><li class=\"advert-explain\" data-v-ee29cec0>For subscribing members, only the first subscription will enjoy a discount, and subsequent renewals will be based on the original price;</li><li class=\"advert-explain\" data-v-ee29cec0>The final right of interpretation of this activity belongs to Mobvoi.</li>", 5);

var _hoisted_51 = [_hoisted_46];
var _hoisted_52 = {
  key: 1,
  class: "advert-explain-inner"
};

var _hoisted_53 = /*#__PURE__*/_createStaticVNode("<li class=\"advert-explain\" data-v-ee29cec0>The mid-year special offer will last from 2024.07.04 to 2024.07.18;</li><li class=\"advert-explain\" data-v-ee29cec0>During the event, users can enjoy a discount of up to 50% off (including extra membership days) to open a membership;</li><li class=\"advert-explain\" data-v-ee29cec0>After the recharge is successful, you can check the validity period of your membership in &quot;Home-Sleep Card-Start Sleep-VIP&quot;;</li><li class=\"advert-explain\" data-v-ee29cec0>After the activity starts, purchase the corresponding membership and get extra membership days; the more you buy, the more you get;</li><li class=\"advert-explain\" data-v-ee29cec0>The extra membership days will be credited later, and will be credited on 2024.07.25 Distributed before 24:00:00;</li><li class=\"advert-explain\" data-v-ee29cec0>The final right of interpretation of this activity belongs to Mobvoi.</li>", 6);

var _hoisted_59 = [_hoisted_53];

var _hoisted_60 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "see-more-btn-inner"
  }, "PURCHASE NOW", -1);
});

var _hoisted_61 = [_hoisted_60];

var _hoisted_62 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "see-more-btn-inner"
  }, "PURCHASE NOW", -1);
});

var _hoisted_63 = [_hoisted_62];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_van_loading = _resolveComponent("van-loading");

  var _component_no_net_tip = _resolveComponent("no-net-tip");

  return $data.isloading ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_loading, {
    size: "24",
    color: "#3F96F3"
  })])) : $data.noNet ? (_openBlock(), _createBlock(_component_no_net_tip, {
    key: 1
  })) : (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: _normalizeClass(["advert", $data.isiOS ? 'ios' : 'android']),
    oversea: !$data.oversea0
  }, [$data.isiOS ? (_openBlock(), _createElementBlock("img", _hoisted_3)) : (_openBlock(), _createElementBlock("img", _hoisted_4)), _hoisted_5, _hoisted_6, _createElementVNode("div", _hoisted_7, [_createTextVNode(_toDisplayString($options.timeLeftText) + " ", 1), $data.discountFlag !== 3 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_hoisted_8, $data.leftDay ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("span", _hoisted_11, _toDisplayString($data.leftDay), 1)]), _hoisted_12])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_13, [_createElementVNode("span", _hoisted_14, _toDisplayString($data.leftHour), 1)]), _hoisted_15, _createElementVNode("div", _hoisted_16, [_createElementVNode("span", _hoisted_17, _toDisplayString($data.leftMinute), 1)]), _hoisted_18, _createElementVNode("div", _hoisted_19, [_createElementVNode("span", _hoisted_20, _toDisplayString($data.leftSeconds), 1)])], 64)) : _createCommentVNode("", true)]), $data.isiOS ? (_openBlock(), _createElementBlock("div", _hoisted_21, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.iosActivityList, function (item) {
    return _openBlock(), _createElementBlock("div", {
      class: "vip-discount-card",
      key: item.productID
    }, [_createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, _toDisplayString(item.name), 1), item.discount ? (_openBlock(), _createElementBlock("div", _hoisted_26, "About " + _toDisplayString(item.discount) + " off", 1)) : _createCommentVNode("", true)]), item.isFirst ? (_openBlock(), _createElementBlock("div", _hoisted_27, "first")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createElementVNode("span", _hoisted_30, _toDisplayString(item.displayPrice), 1)]), _createElementVNode("div", {
      class: "buy-btn",
      onClick: function onClick($event) {
        return $options.goToHcActivityVipPage(item.productID);
      }
    }, "Purchase now", 8, _hoisted_31)])])])]);
  }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_32, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.vipTypeList, function (item) {
    return _openBlock(), _createElementBlock("div", {
      class: "vip-discount-card",
      key: item.id
    }, [_createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_createTextVNode(_toDisplayString(item.title) + " ", 1), item.discount ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(item.discount), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_createTextVNode(_toDisplayString(item.priceUnit), 1), _createElementVNode("span", _hoisted_39, _toDisplayString(item.price), 1)]), _createElementVNode("div", _hoisted_40, [item.origin ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_createTextVNode(_toDisplayString(item.priceUnit) + _toDisplayString(item.origin), 1)], 64)) : _createCommentVNode("", true)])])]), _createElementVNode("div", {
      class: "buy-btn",
      onClick: function onClick($event) {
        return $options.openVip(item.id);
      }
    }, "Purchase now", 8, _hoisted_41)]), _createElementVNode("div", _hoisted_42, _toDisplayString(item.describe), 1)]);
  }), 128))])), _createElementVNode("div", _hoisted_43, [_hoisted_44, $data.isiOS ? (_openBlock(), _createElementBlock("ul", _hoisted_45, _hoisted_51)) : (_openBlock(), _createElementBlock("ul", _hoisted_52, _hoisted_59))]), $data.isiOS ? (_openBlock(), _createElementBlock("div", {
    key: 4,
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return $options.goToHcActivityVipPage();
    }),
    class: "see-more-btn"
  }, _hoisted_61)) : (_openBlock(), _createElementBlock("div", {
    key: 5,
    onClick: _cache[1] || (_cache[1] = function () {
      return $options.openVipPage && $options.openVipPage.apply($options, arguments);
    }),
    class: "see-more-btn"
  }, _hoisted_63))], 10, _hoisted_2));
}